<template>
  <div class="i-team-multi-picker">
    <div class="field-label">
      {{ resolvedLabel }}
    </div>
    <multiselect
      ref="multi"
      v-model="selected"
      label="name"
      trackBy="id"
      :options="sharedDrives"
      :multiple="false"
      :placeholder="resolvedPlaceholder"
      @search-change="onSearch"
      @select="onSelect"
      @remove="onRemove"
      @open="onOpen"
      @keydown.native="onKeydown"
    >
      <template #noOptions>
        {{ $t('common.listIsEmpty') }}
      </template>
      <template #noResult>
        {{ $t('common.noElementsFound') }}
      </template>
      <template slot="option" slot-scope="{ option }">
        <div>{{ option.name }}</div>
        <div v-if="showInfo" class="i-user-picker-email">{{ option.primaryEmail }}</div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {listSharedDrives} from "@/services/api/google/recovery/shared-drive/sharedDrive";
import {defaultPagination} from "@/services/pagination";

export default {
  name: 'ISharedDrivePicker',
  components: {Multiselect},
  props: {
    value: {},
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    filter: {
      type: Object,
      default: {
        "statuses": [
          1, 2, 4
        ]
      }
    },
    showInfo: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    resolvedLabel() {
      return this.label || this.$t('recovery.search.labels.sharedDrive');
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('common.searchForSharedDrives');
    }
  },

  data() {
    return {
      selected: null,
      sharedDrives: []
    }
  },

  methods: {
    onSearch(searchTerm) {
      this.sharedDrives = [];
      this.loadSharedDrives(searchTerm)
    },
    loadSharedDrives(search = null) {
      listSharedDrives({
        pagination: {
          ...defaultPagination(),
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: this.filter
      })
        .then(({result, pagination}) => {
          this.sharedDrives = result;
        })
    },
    onSelect(data) {
      this.$emit('input', data)
    },
    onRemove(data) {
      this.$emit('input', null)
    },
    onOpen() {
      this.$nextTick(this.scrollHighlightedIntoView);
    },
    onKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        this.$nextTick(this.scrollHighlightedIntoView);
      }
    },
    scrollHighlightedIntoView() {
      const multi = this.$refs.multi;
      if (!multi || !multi.$el) return;

      const wrapper = multi.$el.querySelector('.multiselect__content-wrapper');
      if (!wrapper) return;

      const highlighted = wrapper.querySelector('.multiselect__option--highlight');
      if (highlighted) {
        highlighted.scrollIntoView({block: 'nearest'});
      }
    },
  },

  created() {
    if (this.value?.status != 4) {
      this.selected = this.value;
    }

    this.loadSharedDrives();
  },
}
</script>

<style lang="scss">
@import "ITeamPicker";
</style>
